import { render, staticRenderFns } from "./ResultRoadLobby.vue?vue&type=template&id=64121693&"
import script from "./ResultRoadLobby.vue?vue&type=script&lang=js&"
export * from "./ResultRoadLobby.vue?vue&type=script&lang=js&"
import style0 from "./ResultRoadLobby.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports